export const Footer = () => (
  <div className="footer">
    <p>Everything runs in your browser, so no images are saved.</p>
    <p>
      Created by{' '}
      <a href="https://www.jamesbaum.co.uk" title="James Baum's site">
        @whostolemyhat
      </a>
    </p>
  </div>
);
